// Default age of majority. Some countries recognize a different legal age;
// add ISO country-id overrides to MIN_LEGAL_AGE_BY_COUNTRY as the business confirms them.
export const DEFAULT_MIN_LEGAL_AGE = 18;

const MIN_LEGAL_AGE_BY_COUNTRY = {};

export const getMinLegalAge = (countryId) => {
    return MIN_LEGAL_AGE_BY_COUNTRY[countryId] ?? DEFAULT_MIN_LEGAL_AGE;
};

export const calculateAge = (day, month, year, referenceDate = new Date()) => {
    let age = referenceDate.getFullYear() - year;
    const hasHadBirthdayThisYear =
        referenceDate.getMonth() + 1 > month ||
        (referenceDate.getMonth() + 1 === month && referenceDate.getDate() >= day);
    if (!hasHadBirthdayThisYear) {
        age -= 1;
    }
    return age;
};

export const isUnderLegalAge = (day, month, year, countryId, referenceDate = new Date()) => {
    return calculateAge(day, month, year, referenceDate) < getMinLegalAge(countryId);
};
